import InfoIconTooltip from '@ui/InfoIconTooltip';
import { Body5, Container } from '@ui';
import React from 'react';
import styled from 'styled-components';

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const Label = styled.div``;
const LabelAction = styled.div``;
const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const LabelRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 32px;
`;

export const Field = ({ label, infoIcon, labelAction, component, boldLabel }) => {
  return (
    <FieldWrapper>
      <LabelRowWrapper>
        {label && (
          <Container row verticallyCenter>
            <Label>
              <Body5 bold={boldLabel}>{label}</Body5>
            </Label>
            {infoIcon && (
              <Container left={7} top={1}>
                <InfoIconTooltip type={infoIcon} />
              </Container>
            )}
          </Container>
        )}
        {labelAction && <LabelAction>{labelAction}</LabelAction>}
      </LabelRowWrapper>

      <ComponentWrapper>{component}</ComponentWrapper>
    </FieldWrapper>
  );
};
